export class MathHelper {
    
static roundToTwoDecimalPlaces(number: number | string): number {
    if (number == null || number === '') {
        return null;
    }
    return +(Math.round((number + "e+2") as any) + "e-2");
}

static roundToDecimalPlaces(number: number | string, fractionDigits: number): number {
    if (number == null || number === '') {
        return null;
    }
    return +(Math.round((number + `e+${fractionDigits}`) as any) + `e-${fractionDigits}`);
}
}